module.exports = __webpack_public_path__ + "media/images/app/products/collection-banner-fbdfe842b53038c5c99f44f70f827205.webp";